/**
 * @Description 周边配套
 */

import { FC, useEffect, useMemo, useState } from 'react';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import Search from './components/Search';
import TableList from './components/TableList';
import { useMethods } from '@lhb/hook';
import { getSpotEvaluationAroundPageShare, getSpotEvaluationAroundPage, postSpotEvaluationCommunityAggregate, postSpotEvaluationCommunityAggregateShare, spotEvaluationCommunityExport, spotEvaluationCommunityMainList } from '@/common/api/spotevaluation';
import { getRadiusNameBySearchTypeAndValue, getTitleSearchTypeNameByValue, SpotTypeEnum } from '@/views/spotevaluation/pages/index/ts-config';
import { BUSINESS_AREA_KEY, COMMUNITY_KEY } from '../../ts-config';
import Community from './components/Community';
// import { Col, Row } from 'antd';
import DetailBlockItem from '@/common/components/business/DetailBlockItem';
import { beautifyThePrice, isObject } from '@lhb/func';
import BusinessArea from './components/BusinessArea';
// import { useBigdataFn } from '@/common/utils/bigdata';
import IconFont from '@/common/components/IconFont';
import ALQStatistics from './components/Community/ALQStatistics';
import { flattenCommunityMainList, isSameCommunity } from '../../../communityMainList';
import { dispatchDownloadRemind } from '@/common/document-event/dispatch';

export interface SurroundProps {
  detail?: any;
  setSurroundingChecked?: any;
  setSurroundingOptions?: any;
  curDetail:any;
  setCurDetail:any;
  tenantId: any;
  shareParams: any;
  drawerData?: any;
  isALQ: boolean;
}

const Surround: FC<SurroundProps> = ({
  detail,
  setSurroundingChecked,
  setSurroundingOptions,
  // curSurroundDetail,
  setCurDetail,
  tenantId,
  drawerData,
  shareParams,
  isALQ,
  ...props
}) => {
  const mainHeight = 521;
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [filters, setFilters] = useState<{ [x: string]: any }>({});// 查询条件
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false);// 是否需要当前页刷新
  const [tableLoading, setTableLoading] = useState<boolean>(true);// 是否需要当前页刷新
  const [isNoData, setIsNodata] = useState<boolean>(false);// 是否没数据
  // const [modColumn, setModColumn] = useState<any[]>([{
  //   value: 'liveNum',
  //   label: '居住人口'
  // }]);// 表头修改
  const [currentCommercialIndex, setCurrentCommercialIndex] = useState<string>('');// 业态key值
  const [communityData, setCommunityData] = useState<any>({});// 周边小区聚合信息
  const [modalALQStatistics, setModalALQStatistics] = useState<any>({
    open: false,
    radius: 0,
    name: '',
    detail: null,
    drawerData: null
  });
  // 是否是商业
  const isBusinessArea = useMemo(() => {
    return String(currentCommercialIndex) === BUSINESS_AREA_KEY;
  }, [currentCommercialIndex]);

  /** 是否是小区 */
  const isCommunity = useMemo(() => {
    return String(currentCommercialIndex) === COMMUNITY_KEY;
  }, [currentCommercialIndex]);
  // 是否是分享
  const isShare = useMemo(() => {
    return shareParams && isObject(shareParams) && Object.keys(shareParams).length > 0;
  }, [shareParams]);

  useEffect(() => {
    if (Object.keys(filters).length && Object.keys(detail).length) {
      setTableLoading(false);
      setSurroundingChecked && setSurroundingChecked(filters);
    }
  }, [filters, detail]);

  const isALQCommunity = isALQ && !tenantId && !isShare;
  const canCommunityExport = Array.isArray(detail?.permissions) &&
    detail.permissions.some(permission => permission?.event === 'spotEvaluation:communityExport');

  const methods = useMethods({

    // 搜索
    onSearch: (values: { [x: string]: string }) => {
      setFilters({ ...values });
    },

    /**
     * @description 从1页重新加载
     */
    reload() {
      setRefreshCurrent(false);
      setFilters({ ...filters });
    },

    loadData: async (params: any) => { // 初始化
      let api: any = '';
      let _params: any = {};
      // _params = {
      //   page: params.page,
      //   size: params.size,
      //   poiSearchType: 1,
      //   radius: filters.distance,
      //   lat: detail.lat,
      //   lng: detail.lng,
      //   codes: filters.codes,
      //   cityName: detail.cityName,
      //   tenantId,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId,
      // };
      const { type, modelConfigId, modelClusterId, radius } = drawerData;
      _params = {
        page: params.page,
        size: params.size,
        poiSearchType: 1,
        lat: detail.lat,
        lng: detail.lng,
        aoiTypeCategoryId: filters.aoiTypeCategoryId,
        secondAoiType: filters.secondAoiType,
        cityName: detail.cityName,
        type,
        modelConfigId,
        radius, // 先兼容接口在type2时也要求传radius的报错
      };
      if (type === SpotTypeEnum.Mall) {
        _params.modelClusterId = modelClusterId;
        _params.radius = filters.distance;
      }
      if (type === SpotTypeEnum.Street) {
        _params.poiSearchType = detail?.poiSearchType;
        _params.radius = detail?.radius;
        _params.poiSearchMinute = detail?.poiSearchMinute;
        _params.poiSearchDistance = detail?.poiSearchDistance;
        _params.points = detail?.points;
      }
      if (tenantId) {
        _params.tenantId = tenantId;
        _params.isShare = true;
      }
      api = tenantId ? getSpotEvaluationAroundPageShare : getSpotEvaluationAroundPage;

      const useMainList = isALQCommunity && isCommunity;
      const data = useMainList ? await spotEvaluationCommunityMainList({
        page: params.page,
        size: params.size,
        poiSearchType: _params.points?.length ? 2 : _params.poiSearchType,
        lng: String(_params.lng),
        lat: String(_params.lat),
        radius: _params.radius,
        points: _params.points,
        secondAoiType: _params.secondAoiType,
      }) : await api(_params, false);
      const { objectList } = data;

      // isCommunity判断是否小区
      // setModColumn(objectList?.find(item => item?.isCommunity) ? [
      //   { value: 'liveNum', label: '居住人口' },
      // ] : [{ value: 'address', label: '地址' }]);

      methods.getCommunityData(_params);

      return {
        dataSource: useMainList ? flattenCommunityMainList(objectList).filter(item => item.overlapDeleteFlag !== true) : (objectList || []).map((item, index) => {
          item.index = (params.page - 1) * params.size + index + 1;
          return item;
        }),
        count: data.totalNum,
      };

    },
    async getCommunityData(params:any) {
      const communityApi = tenantId ? postSpotEvaluationCommunityAggregateShare : postSpotEvaluationCommunityAggregate;
      try {
        const _communityData = await communityApi(params, false);
        setCommunityData(_communityData);
      } catch (error) {
        // 聚合信息失败时不阻断主列表渲染，回退为空数据
        setCommunityData({});
      }
    },
    handleCommunityExport() {
      // 请求成功后触发公共下载提醒，导出结果可在导出记录中查看。
      const isStreet = drawerData?.type === SpotTypeEnum.Street;
      const searchType = detail?.poiSearchType ?? 1;
      const rangeName = isStreet
        ? `${getTitleSearchTypeNameByValue(searchType)}${getRadiusNameBySearchTypeAndValue({
          searchType,
          radius: detail?.radius,
          minute: detail?.poiSearchMinute,
          distance: detail?.poiSearchDistance,
          rangeMode: detail?.rangeMode,
        })}`
        : getRadiusNameBySearchTypeAndValue({
          searchType: 1,
          radius: filters?.distance,
        });
      const imageQueryParams = [
        ['poiSearchType', searchType],
        ['lat', detail?.lat],
        ['lng', detail?.lng],
        ['radius', isStreet ? detail?.radius : filters?.distance],
        ['secondAoiType', filters?.secondAoiType ?? 'null'],
        ['areaName', detail?.areaName],
        ['id', drawerData?.id],
      ];
      const imageUrl = `/pdf/aldcommunity?${imageQueryParams
        .map(([key, value]) => `${key}=${encodeURIComponent(String(value ?? ''))}`)
        .join('&')}`;
      const exportParams = {
        secondAoiType: filters?.secondAoiType ?? null,
        poiSearchType: searchType,
        lng: detail?.lng,
        lat: detail?.lat,
        radius: isStreet ? detail?.radius : filters?.distance,
        points: isStreet ? detail?.points : undefined,
        spotTypeName: isStreet ? '街边店' : '商场店',
        evaluateRangeName: rangeName,
        spotName: drawerData?.poiName || detail?.areaName,
        menuName: '点位测评',
        imageUrl,
      };
      spotEvaluationCommunityExport(exportParams).then(() => {
        dispatchDownloadRemind();
      });
    },
    handleViewStatistics() {
      const { distance } = filters;
      setModalALQStatistics({
        open: true,
        radius: distance,
        name: detail.areaName,
        detail: detail,
        drawerData: drawerData,
      });
    },
  });

  return isNoData ? <></> : (
    <div className={styles['store']} >
      <V2Title divider type='H2' text={`周边配套`}/>
      <Search
        onSearch={methods.onSearch}
        detail={detail}
        setCurDetail={setCurDetail}
        setIsNodata={setIsNodata}
        setSurroundingOptions={setSurroundingOptions}
        tenantId={tenantId}
        drawerData={drawerData}
        currentCommercialIndex={currentCommercialIndex}
        setCurrentCommercialIndex={setCurrentCommercialIndex}
      />
      { isCommunity && <div className={styles.infoGroup}>
        <div className='mr-12' style={{ flex: 1 }}>
          <DetailBlockItem
            className={isALQCommunity ? styles.communityStat : undefined}
            text={isALQCommunity ? '加权平均建成年代' : '户数'}
            num={isALQCommunity
              ? beautifyThePrice(communityData?.avgBuildYear, ',', 'auto')
              : beautifyThePrice(communityData?.totalHouseholds, ',', 'auto')}/>
        </div>
        {isALQ && <div className='mr-12' style={{ flex: 1 }}>
          <DetailBlockItem
            className={isALQCommunity ? styles.communityStat : undefined}
            text={`加权户数`}
            num={beautifyThePrice(communityData?.weightedHomeNumber, ',', 'auto')}/>
        </div>}
        <div className={isALQ && !isShare ? 'mr-12' : ''} style={{ flex: 1 }}>
          <DetailBlockItem
            className={isALQCommunity ? styles.communityStat : undefined}
            text={`平均房价`}
            num={beautifyThePrice(communityData?.avgPrice, ',', 'auto')}
            unit='元/㎡'
          />
        </div>
        {isALQCommunity && <div className={`${styles.communityActions} ${!canCommunityExport ? styles.communityActionsSingle : ''}`}>
          <button type='button' className={styles.viewBtn} onClick={methods.handleViewStatistics}>
            <span className='fs-12 c-006 pl-2'>小区统计</span>
            <IconFont iconHref='iconarrow-right' className='fs-10 c-006'/>
          </button>
          {canCommunityExport && <button type='button' className={styles.viewBtn} onClick={methods.handleCommunityExport}>
            <span className='fs-12 c-006 pl-2'>小区导出</span>
            <IconFont iconHref='iconarrow-right' className='fs-10 c-006'/>
          </button>}
        </div>}
      </div>}
      {
        tableLoading ? <></> : <>
          {(isCommunity && !isALQ) || isBusinessArea ? <>
            {
              isBusinessArea && <BusinessArea
                tenantId={tenantId}
                detail={detail}
                filters={filters}
                // curDetail={props?.curDetail}
                setCurDetail={setCurDetail}
                mainHeight={mainHeight}
                drawerData={drawerData}
                shareParams={shareParams}
              />
            }
            {
              isCommunity && !isALQ && <Community
                tenantId={tenantId}
                detail={detail}
                filters={filters}
                curDetail={props?.curDetail}
                setCurDetail={setCurDetail}
                mainHeight={mainHeight}
                drawerData={drawerData}
                getCommunityData={methods.getCommunityData}
              />
            }
          </>
            : <TableList
              mainHeight={mainHeight}
              filters={filters}
              onFetch={methods.loadData as any}
              refreshCurrent={refreshCurrent}
              // modColumn={modColumn}
              isCommunity={isCommunity}
              isALQCommunity={isALQCommunity}
              rowClassName={(record) => {
                // 与数据部门确定，会出现名字相同的数据，但是其他字段会不同
                const isSame = isALQCommunity && isCommunity ? isSameCommunity(record, props?.curDetail) : record.name === props?.curDetail?.name && record.lng === props?.curDetail?.lng && record.lat === props?.curDetail?.lat;
                return isSame ? 'checked pointer' : 'pointer';
              }}
              onRow={record => {
                return {
                  onClick: () => {
                    setCurDetail(record);
                    // bigdataFn('6040c893-8283-4852-90af-421553b6bb5a', '详情-周边配套-点击列表', '点击了详情-周边配套-点击列表', { op_block: '开店区域-详情页', op_event: ``, });
                  }, // 点击行
                };
              }}
              onPaginationChange={() => {
                // bigdataFn('aea6572d-e826-424d-9ba0-ef71e7b79852', '详情-周边配套-列表跳页', '点击了详情-周边配套-列表跳页', { op_block: '开店区域-详情页', op_event: ``, });
              }}
            /> }
        </>
      }
      <ALQStatistics
        modalData={modalALQStatistics}
        close={() => setModalALQStatistics((state) => ({ ...state, open: false }))}
      />
    </div>
  );
};

export default Surround;
